<script setup lang="ts">
import { NIcon } from '@nio-fe/icon';
import { onActivated, onMounted, ref } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import { useRoute, useRouter } from 'vue-router';
import { useGlobalRouteStore } from '@/store/globalRouteStore';
const mateStoreStore = useMatestoreStore();
const router = useGlobalRouteStore();
const dashboardMenuStatus = ref<boolean>(true);
const dashboards = mateStoreStore.dashboardMicroApps;
const route = useRoute();
const handleToggle = () => {
  dashboardMenuStatus.value = !dashboardMenuStatus.value;
};
const handleSelectMenu = (micro) => {
  router.push(micro.fullPath);
};
</script>

<template>
  <div
    :class="{ dashboard: true, 'dashboard--menu-fold': !dashboardMenuStatus }"
  >
    <div class="dashboard-menu" v-show="dashboardMenuStatus">
      <div class="dashboard-title">
        <NIcon name="dashboard_filled" size="28" />
        <h3>仪表盘</h3>
      </div>
      <div
        :class="{
          'dashboard-menu-item': true,
          'dashboard-menu-item--active': route.fullPath.includes(item.fullPath),
        }"
        v-for="item in dashboards"
        @click="handleSelectMenu(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="dashboard-container">
      <div
        class="dashboard-menu-handler"
        @click="handleToggle"
        v-tooltip.right="dashboardMenuStatus ? '收起' : '展开'"
      >
        <NIcon :name="'fold'" />
      </div>
      <div class="micro-container">
        <keep-alive-vue3 :cache="true"> </keep-alive-vue3>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.dashboard {
  background: #f4f5f7;
  height: 100%;
  padding-left: 160px;
  position: relative;
  &--menu-fold {
    padding-left: 0;
  }
}
.dashboard-container {
  padding: 20px 20px 20px 32px;
  background: #fff;
  width: 100%;
  position: relative;
  height: 100%;
}
.dashboard-menu {
  width: 160px;
  min-width: 160px;
  padding: 14px 20px 14px 8px;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-right: 1px solid #f4f5f7;
}
.dashboard-menu-item {
  border-radius: 4px;
  padding: 9px 10px;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 8px;
  cursor: pointer;
  color: #242629;
  &:hover,
  &:active,
  &--active {
    background: #e7f4f6;
    color: #178ca6;
  }
}

.dashboard-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .n-icon {
    margin-right: 8px;
  }
  h3 {
    margin: 0;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
}

.dashboard-menu-handler {
  position: absolute;
  left: -2px;
  top: 26px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 0 24px 24px 0;
  background: #fff;
  filter: drop-shadow(0px 3px 7px rgba(0, 0, 0, 0.06));
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    color: #1e9eaf;
  }
  :active {
    color: #0e6881;
  }
  .handler-bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
}
.micro-container {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
}
</style>
